import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function projectsListRequest(urlParams = {}) {
  return request({
    method: 'get',
    url: urlParams.page ? urls.projectsListPaginated : urls.projectsList,
    urlParams,
    headers: getHeaders(),
  });
}

export async function projectCreateRequest(data) {
  return request({
    method: 'post',
    url: urls.projectCreate,
    data,
    headers: getHeaders(),
  });
}

export async function projectUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.projectUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function projectDetailRequest(urlParams, includes = []) {
  return request({
    method: 'get',
    url: `${urls.projectDetail}\\?includes=${includes.join(',')}`,
    urlParams,
    headers: getHeaders(),
  });
}

export async function projectDeleteRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.projectDelete,
    urlParams,
    headers: getHeaders(),
  });
}

export async function generateTokenRequest(urlParams) {
  return request({
    method: 'POST',
    url: urls.generateToken,
    urlParams,
    headers: getHeaders(),
  });
}

export async function updateHubspotTokenRequest(urlParams, data) {
  return request({
    method: 'PUT',
    url: urls.updateHubspotToken,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function testLlmPrompt(projectId, companyId, prompt) {
  return request({
    method: 'POST',
    url: `/projects/${projectId}/test_llm_prompt`,
    data: {
      company_id: companyId,
      prompt,
    },
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/projects.js